import styles from './NewBadge.module.scss'

const NewBadge = ({ className, children = 'new', style }) => (
  <span style={style} className={styles.badge + ' ' + className}>
    {children}
  </span>
)

export default NewBadge
